import { render, staticRenderFns } from "./Galaxy.vue?vue&type=template&id=d5e0cfc8&scoped=true"
import script from "./Galaxy.vue?vue&type=script&lang=js"
export * from "./Galaxy.vue?vue&type=script&lang=js"
import style0 from "./Galaxy.vue?vue&type=style&index=0&id=d5e0cfc8&prod&lang=scss&scoped=true"
import style1 from "./Galaxy.vue?vue&type=style&index=1&id=d5e0cfc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e0cfc8",
  null
  
)

export default component.exports